import BaseModel from "./base/baseModel";

export default class TemplateRelatorioModel extends BaseModel {
    usuarioId: number = null;
    campos: string = null;
    relatorio: number = null;
    descricao: string = null;
    id: string = null;
}
